import React, { useEffect } from "react";

interface Props {
  src: string;
  alt?: string;
  code?: string;
  onClose: () => void;
}

const ImageLightbox: React.FC<Props> = ({ src, alt, code, onClose }) => {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="image-lightbox-overlay"
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1050,
        padding: 16,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: "90%", maxHeight: "90%", position: "relative" }}
      >
        <button
          aria-label="Fechar"
          onClick={onClose}
          style={{
            position: "absolute",
            right: -8,
            top: -8,
            background: "#fff",
            border: "none",
            borderRadius: "50%",
            width: 32,
            height: 32,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
          }}
        >
          ✕
        </button>

        <img
          src={src}
          alt={alt}
          style={{ width: "100%", height: "auto", borderRadius: 6 }}
        />

        {code && (
          <div
            style={{
              marginTop: 8,
              color: "#fff",
              textAlign: "center",
              fontSize: 13,
              textShadow: "0 1px 2px rgba(0,0,0,0.6)",
            }}
          >
            Código: {code}
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageLightbox;
